// HeaderPro is kept as a compatibility shim. The site now ships a single
// `MainHeader` that detects the active role from the auth stores and
// renders the right nav links / auth area automatically — keeping two
// parallel headers in sync turned out to be fragile.
//
// New code should import { MainHeader } from './MainHeader' directly.
import { MainHeader } from './MainHeader';

export function HeaderPro() {
  return <MainHeader isProfessional />;
}
